import { consola } from 'consola'

/**
 * Гейтит уровень логирования по окружению — фронтовый аналог backend
 * `utils/environmentLogger.js` (verbose только в development/test).
 *
 * Зачем: по умолчанию глобальный `consola` в браузере имеет level 3 (info),
 * поэтому `logger.info(...)` / `logger.log(...)` из всех `consola.withTag(...)`
 * сыпались в консоль и в проде → спам. Здесь один раз задаём уровень:
 *   - dev (`nuxt dev`, NODE_ENV !== 'production') → info (level 3). Debug/trace-спам
 *     (огромные объекты зон/корзины) заметно тормозит SSR-рендер: вывод в консоль
 *     Windows синхронный. Вернуть debug: VITE_CONSOLA_LEVEL=4 (или 5 для trace);
 *   - любая прод-сборка → только warn + error/fatal (как на бэке).
 *
 * Важно: уровень выставляется на ВЕРХНЕМ УРОВНЕ модуля (а не внутри setup).
 * `consola.withTag()` снимает СНИМОК уровня в момент создания дочернего логгера
 * (см. core.mjs: withTag → create → new Consola). Тегированные логгеры в
 * composables/компонентах/сторах создаются при первом импорте — это происходит
 * уже ПОСЛЕ выполнения плагинов, поэтому они подхватят выставленный здесь уровень.
 * Чтобы плагин гарантированно отрабатывал раньше остальных, он зарегистрирован
 * первым в массиве `plugins` в nuxt.config и имеет префикс `00.` в имени файла.
 */
consola.level = import.meta.dev
  ? Number(import.meta.env.VITE_CONSOLA_LEVEL ?? 3)
  : 1

export default defineNuxtPlugin(() => {
  // Логика целиком в top-level выше — плагин нужен лишь как точка входа,
  // которую Nuxt выполняет на старте (и на сервере, и на клиенте).
})
